import { render, staticRenderFns } from "./ExchangeRestore.vue?vue&type=template&id=a21b4ef0"
import script from "./ExchangeRestore.vue?vue&type=script&lang=js"
export * from "./ExchangeRestore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports